<template>
  <div>
    <div>
      <div class="sixteentosix omt-6 omt-md-25 sixteentosix-wrap">
        <div class="new-background-wrap">
          <div
            class="kachelimage header-image zoom-image"
            style="
              background: url('/static/img/video-main-banner.svg');
              background-position: top !important;
            "
          ></div>
          <div class="headline-wrap">
            <div class="headline">
              <div class="text-subtitle-2 text-md-h5">
                {{ $t("Digital Twin") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb />
    <div class="mx-0 row align-items-start">
      <div class="col-xl-12 px-8 pr-md-10 pr-lg-0 old-digital-links">
        <div
          class="px-md-4 pt-4 mx-0 pa-0 row justify-content-sm-between justify-content-center"
        >
         <!--  <div class="mt-5">
            <h1>Start Digital Twin Sample Simulation ( WebGL)</h1>
            <a class="simulation" @click="startSimulation">Start Simulation</a>
          </div> -->
          <!-- <div class="mt-5">
    <h1>Start Digital Twin Sample Simulation  (RDC)</h1>
    <a class="simulation" href="https://go.getscreen.me/a1z-94c-8ux" target="_blank">Start Simulation</a>
  </div> -->
        <!--  <div class="mt-5">
            <h1>Start Digital Twin Sample Simulation (Web Shell)</h1>
            <a
              class="simulation"
              href="https://128.199.19.96:4200/"
              target="_blank"
              >Start Simulation</a
            >
          </div> -->
        </div>
      </div>
      <div class="digital-discription-wrap col-xl-12">
        <div  class="px-md-4 pt-4 mx-0 pa-0 row justify-content-sm-between justify-content-center">
          <div class="digital-discription col-md-6">
            The Digital Twin learning walkthrough offers an interactive, real-time simulation of physical systems, providing a comprehensive understanding of their functions. This immersive educational tool enhances learning by visualizing complex processes and allowing hands-on experimentation.
          </div>
          <hr class="col-xl-12 row m-0 p-0 digital-card-wrap-1"></hr>
          <div class="col-xl-12 row m-0 p-0 digital-card-wrap">
              <div class="col-xl-4 digital-card">
                  <div class="digital-img">
                      <img src="/static/img/card-image.svg">
                  </div>
                  <div class="card-discription">
                      <h2>Digital twin subject title</h2>
                      <p>The Digital Twin learning walkthrough offers interactive, real-time simulations of physical systems for enhanced understanding through immersive visualization and hands-on experimentation.</p>
                      <a class="simulation" @click="startSimulation">Learn More
                        <svg class="arrow-svg" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.52034 1.95953C8.22734 3.43106 8.64034 5.15875 8.64034 6.98291V7.00063V6.99975V7.01638C8.64034 8.84075 8.22734 10.5682 7.48971 12.1111L7.52034 12.0398H5.07077C5.95605 10.6078 6.48084 8.87159 6.48084 7.01288V6.99909V6.99975V6.97503C6.48372 5.18956 5.98957 3.43852 5.05371 1.91797L5.07777 1.95997L7.52034 1.95953Z" fill="#00457E"/>
<path d="M9.35851 6.99875V6.97884C9.35851 5.16278 8.97263 3.43728 8.27832 1.87891L8.31004 1.95875H10.4739L12.9244 6.98081L10.4739 12.0387H8.31004C8.97263 10.5602 9.35829 8.8345 9.35829 7.01844V6.99766V6.99853L9.35851 6.99875Z" fill="#00457E"/>
</svg>
                      </a>
                  </div>
              </div>
              <div class="col-xl-4 digital-card">
                  <div class="digital-img">
                      <img src="/static/img/card-image.svg">
                  </div>
                  <div class="card-discription">
                      <h2>Digital twin subject title</h2>
                      <p>The Digital Twin learning walkthrough offers interactive, real-time simulations of physical systems for enhanced understanding through immersive visualization and hands-on experimentation.</p>
                      <a class="simulation" @click="startSimulation">Learn More
                        <svg class="arrow-svg" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.52034 1.95953C8.22734 3.43106 8.64034 5.15875 8.64034 6.98291V7.00063V6.99975V7.01638C8.64034 8.84075 8.22734 10.5682 7.48971 12.1111L7.52034 12.0398H5.07077C5.95605 10.6078 6.48084 8.87159 6.48084 7.01288V6.99909V6.99975V6.97503C6.48372 5.18956 5.98957 3.43852 5.05371 1.91797L5.07777 1.95997L7.52034 1.95953Z" fill="#00457E"/>
<path d="M9.35851 6.99875V6.97884C9.35851 5.16278 8.97263 3.43728 8.27832 1.87891L8.31004 1.95875H10.4739L12.9244 6.98081L10.4739 12.0387H8.31004C8.97263 10.5602 9.35829 8.8345 9.35829 7.01844V6.99766V6.99853L9.35851 6.99875Z" fill="#00457E"/>
</svg>
                      </a>
                  </div>
              </div>
              <div class="col-xl-4 digital-card">
                  <div class="digital-img">
                      <img src="/static/img/card-image.svg">
                  </div>
                  <div class="card-discription">
                      <h2>Digital twin subject title</h2>
                      <p>The Digital Twin learning walkthrough offers interactive, real-time simulations of physical systems for enhanced understanding through immersive visualization and hands-on experimentation.</p>
                      <a class="simulation" @click="startSimulation">Learn More
                        <svg class="arrow-svg" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.52034 1.95953C8.22734 3.43106 8.64034 5.15875 8.64034 6.98291V7.00063V6.99975V7.01638C8.64034 8.84075 8.22734 10.5682 7.48971 12.1111L7.52034 12.0398H5.07077C5.95605 10.6078 6.48084 8.87159 6.48084 7.01288V6.99909V6.99975V6.97503C6.48372 5.18956 5.98957 3.43852 5.05371 1.91797L5.07777 1.95997L7.52034 1.95953Z" fill="#00457E"/>
<path d="M9.35851 6.99875V6.97884C9.35851 5.16278 8.97263 3.43728 8.27832 1.87891L8.31004 1.95875H10.4739L12.9244 6.98081L10.4739 12.0387H8.31004C8.97263 10.5602 9.35829 8.8345 9.35829 7.01844V6.99766V6.99853L9.35851 6.99875Z" fill="#00457E"/>
</svg>
                      </a>
                  </div>
              </div>
          </div>
          <hr class="col-xl-12 row m-0 p-0 digital-card-wrap-1"></hr>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Breadcrumb from "./Breadcrumbs.vue";

export default {
  components: {
    Breadcrumb,
  },

  data() {
    return {};
  },

  watch: {},

  mounted() {},

  methods: {
    startSimulation() {
      this.$axios
        .get("/api/unitycontroller/start-simulation", {})
        .then(function (response) {
          const simulationUrl = response.data.simulationUrl;
          if (simulationUrl) {
            window.open(simulationUrl, "_blank");
          } else {
            console.error("Simulation URL not returned");
          }
        });
    },
  },
};
</script>
<style scoped>
.simulation {
  color: blue;
}
</style>


